module.exports = __webpack_public_path__ + "static/img/27ok.ffc88db4.webp";